import {Component} from '@angular/core';
import {NavController, NavParams} from "ionic-angular";
import {GlobalProvider} from "../../providers/global/global";
import {NoteService} from "../../store/note/note.service";
import {AuditEntity} from "../../store/audit/audit.entity";
import {NoteEntity} from "../../store/note/note.entity";
import {AuditService} from "../../store/audit/audit.service";

/**
 * Generated class for the BemerkungstextvorlagenComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
  selector: 'anmerkungstextvorlagen',
  templateUrl: 'anmerkungstextvorlagen.html'
})
export class AnmerkungstextvorlagenPage {

  public vorlagen: Array<{title: string, category: string}>;
  public selectedVorlage: any = null;
  private pruefung: AuditEntity;
  public showTemplates: boolean = false;
  public isOwner: boolean = false;

  constructor(public navCtrl: NavController,
              private navParams: NavParams,
              public globalProvider: GlobalProvider,
              public noteService: NoteService,
              private auditService: AuditService) {

    this.selectedVorlage = this.navParams.get('selectedVorlage');
    this.pruefung = this.navParams.get('pruefung');
    this.isOwner = this.pruefung.ownerId === this.globalProvider.user.uuid;
  }

  public select(vorlage: {title: string, category: string}): void {
    this.selectedVorlage = JSON.parse(JSON.stringify(vorlage));
    this.showTemplates = false;
  }

  public back(): void {
    this.selectedVorlage = null;
    this.showTemplates = false;
  }

  public add(): void {
    if(!this.pruefung.anmerkungen){
      this.pruefung.anmerkungen = [];
    }
    this.pruefung.anmerkungen.push(this.selectedVorlage.title);
    this.auditService.set(this.pruefung, false);
    // this.dataProvider.updateDocument(this.rootElement);
    this.selectedVorlage = null;
    this.showTemplates = false;
  }

  public save(): void {

    const newNote: NoteEntity = {
      docType: 'note',
      docName: 'Anmerkung',
      title: this.selectedVorlage.title,
      category:this.selectedVorlage.category,
      system: false,
    };

    this.noteService.add(newNote, false);
    this.selectedVorlage = null;
    this.showTemplates = false;
  }

  public newAnmerkung():void {
    this.selectedVorlage = {title: "", category: null};
  }

  public chooseAnmerkung():void {
    this.showTemplates = true;
  }

  public delete(anmerkung: string):void {
    this.pruefung.anmerkungen = this.pruefung.anmerkungen.filter((_anmerkung) => {
      return _anmerkung !== anmerkung;
    });
    this.auditService.set(this.pruefung, false);
  }

  public setCategoryName(name): void {
    this.selectedVorlage.category = name;
  }

}



// WEBPACK FOOTER //
// ./src/pages/anmerkungstextvorlagen/anmerkungstextvorlagen.ts